import { Text, VStack, IconButton } from '@chakra-ui/react';
import { SFQuestionMarkCircle } from '@assets/icons';
import { getEnvironmentName } from '@util/helpers';

const StepContentsContainer = ({ title, children, ...props }) => {
  return (
    <VStack
      bgColor='surface.surfaceBright'
      p={{ base: 4, md: 12 }}
      minH={{ base: 'calc(100dvh - 260px)', md: '520px' }}
      maxH={{ base: 'calc(100dvh - 260px)', md: '520px' }}
      w='full'
      overflowY={{ base: 'scroll', md: 'unset' }}
      rounded='lg'
      shadow='lg'
      position='relative'
      {...props}
    >
      {getEnvironmentName() === 'production' && (
        <IconButton
          variant='link'
          isRound
          _hover={{ opacity: 0.6 }}
          icon={
            <SFQuestionMarkCircle
              fill='white'
              boxSize={5}
            />
          }
          id='intercom-support'
          position='absolute'
          top={3}
          right={3}
          zIndex={1}
        />
      )}
      {title && (
        <Text
          variant='headline-md'
          textAlign='center'
          w='full'
        >
          {title}
        </Text>
      )}
      {children}
    </VStack>
  );
};

export default StepContentsContainer;
